@if (activeSysMsgData.length > 0) {
<div class="system-msg-wrapper">
  <div class="system-popup-modal-header" [ngClass]="{'add-shadow': minimise}">
    <div class="system-msg-popup-title">
      <span class="title-center">
        @if (activeSysMsgData.length > 1) {
<span class="bell-icn-wrapper" (click)="togglePopover()">
          <i class="fa fa-bell-o bell-icn" aria-hidden="true"></i>
          <b class="notif-count">{{ activeSysMsgData.length }}</b>
        </span>
}
        <span class="title-text" [ngClass]="{'title-wrapper': activeSysMsgData.length > 1}">
          {{ selectedSysMsgData.notif_msg_title }}
        </span>
        <button type="button"
                class="header-icon-btn toggle-btn"
                [attr.title]="minimise ? 'Expand' : 'Collapse'"
                [attr.aria-label]="minimise ? 'Expand' : 'Collapse'"
                (click)="minimise = !minimise">
          <span class="fa" [ngClass]="{'fa-chevron-down': minimise, 'fa-chevron-up': !minimise}"></span>
        </button>
      </span>
    </div>
    <button type="button"
            class="header-icon-btn close-btn"
            title="Close"
            aria-label="Close"
            (click)="cancelNotifModal()">
      <span class="Appkit4-icon icon-close-fill" aria-hidden="true"></span>
    </button>
  </div>

  @if (showPopover) {
<div class="active-sys-notif-popover">
    <div class="hdr">
      <span style="font-weight: 500;">System Message Notifications</span>
    </div>
    <div class="active-list">
      @for (activeList of activeSysMsgData; track $index; let i = $index) {
<ul class="active-list-items" (click)="selectSysNotif(activeList)">
        <li><i class="fa fa-envelope-o icn" aria-hidden="true"></i></li>
        <li class="list-title">{{ activeList.notif_msg_title }}</li>
      </ul>
}
    </div>
  </div>
}

  <div class="system-msg-panel" [class.is-open]="!minimise">
    <div class="system-msg-panel-inner">
      <div class="system-popup-modal-body">
        <div class="notification-html-content" [innerHTML]="notificationBodyHtml"></div>
      </div>

      <div class="system-msg-popup-ftr">
        <label class="dont-show-again">
          <input type="checkbox"
                 [ngModel]="checkNotif"
                 (ngModelChange)="checkNotif = $event ? 1 : 0; minimise = true; notifCong()">
          <span>Do Not show this Message again.</span>
        </label>
      </div>
    </div>
  </div>
</div>
}
